function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { GroupsApiService } from "./Services/GroupsApiService";
import { UserService } from "./Services/UserService";
import { OAuthService } from './Services/OAuthService';
import { CardBuilder } from "./Helpers/CardBuilder";
import { QueryStringFilter } from "./Shared/QueryStringFilter";
import { AttributeFilter } from "./Shared/AttributeFilter";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { FormManager } from './Helpers/FormManager';
import { ErrorBuilder } from "./Helpers/ErrorBuilder";
import { LocalStorageManager } from './Shared/LocalStorageManager';
import { Configuration } from "./Shared/Configuration";
var _isSuggestGroupModeKeyName = "SuggestGroupMode";
export var MppGroupFinder = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppGroupFinder, _ComponentBase);

  var _super = _createSuper(MppGroupFinder);

  function MppGroupFinder() {
    _classCallCheck(this, MppGroupFinder);

    return _super.call(this);
  }

  _createClass(MppGroupFinder, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        if (!!this._$searchButton) {
          if (this.loadAttributes()) {
            this._$searchButton.click();
          }
        }
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.countGroupInquiries = this.getAttribute("countgroupinquiries") || false;
      this.showFullGroups = this.getAttribute("showfullgroups") || false;
      this.showFutureGroups = this.getAttribute("showfuturegroups") || true;
      this.targetUrl = this.getAttribute("targeturl") || this.getAttribute("target");
      this.ministryId = this.getAttribute("ministryid") || 0;
      this.groupFocusId = this.getAttribute("groupfocusid") || 0;
      this.showSuggestAGroupButton = this.getAttribute("showsuggestagroupbutton") || false;
      this.groupTypeIdAttribute = this.getAttribute("grouptypeid");
      var attributesChanged = false;

      if (!!this._$searchForm) {
        attributesChanged = AttributeFilter.ApplyFilter(this, this._$searchForm);
      }

      this.ShowHideSuggestGroupButton();
      return true;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this,
            _mppWidgetsConfigValu;

        var i18n, mppWidgetsConfigValues, groupsService;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new I18N(MppGroupFinder.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context2.sent;
                this._i18n = i18n; //Load initial values of tag attributes:

                this.loadAttributes();
                _context2.next = 7;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 7:
                mppWidgetsConfigValues = _context2.sent;
                this._groupDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.groupDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id";

                if (!this.groupTypeIdAttribute) {
                  this._currentUrl = new URL(window.location.href);
                  this.groupTypeIdAttribute = this._currentUrl.searchParams.get("grouptypeid") || "0";
                }

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container" id="group-finder-container"><div class="mppw-form-wrapper"><h1>${ i18n.pageTitle }</h1><form class="mppw-form mppw-form-validate" id="searchForm"><div class="mppw-form-field mppw-form-field__static-container"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ i18n.congregationLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option" type="text" id="keyword"/> <label class="mppw-form-field__label" for="keyword">${ i18n.keyWordLabel }</label></div><div class="mppw-right"><a class="mppw-btn secondary mppw-btn--small" href="#" id="advancedSearchLink" data-searchmode="0">${i18n.showAdvancedSearchLabel }</a></div><div id="advancedSearchSection" style="display: none"><div class="mppw-form-field mppw-form-field__static-container"><select name="parentGroupId" class="mppw-form-field__control search-option advanced-option" id="parentGroupId" value=""></select> <label class="mppw-form-field__label" for="parentGroupId">${ i18n.parentGroupLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="cityPostalCode" class="mppw-form-field__control search-option advanced-option" type="text" id="cityPostalCode"/> <label class="mppw-form-field__label" for="cityPostalCode">${ i18n.cityOrPostalCodeLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="groupFocusId" class="mppw-form-field__control search-option advanced-option" id="groupFocusId" value=""></select> <label class="mppw-form-field__label" for="groupFocusId">${ i18n.groupFocusLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="lifeStageId" class="mppw-form-field__control search-option advanced-option" id="lifeStageId" value=""></select> <label class="mppw-form-field__label" for="lifeStageId">${ i18n.lifeStageLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><div class="mppw-form-field__control meeting-days" value=""><label><input name="meetingDays" value="1" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="1" data-filterdayname="sun"/> <span class="mppw-checkbox"></span>${ i18n.sundayLabel }</label> <label><input name="meetingDays" value="2" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="2" data-filterdayname="mon"/> <span class="mppw-checkbox"></span>${ i18n.mondayLabel }</label> <label><input name="meetingDays" value="3" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="4" data-filterdayname="tue"/> <span class="mppw-checkbox"></span>${ i18n.tuesdayLabel }</label> <label><input name="meetingDays" value="4" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="8" data-filterdayname="wed"/> <span class="mppw-checkbox"></span>${ i18n.wednesdayLabel }</label> <label><input name="meetingDays" value="5" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="16" data-filterdayname="thu"/> <span class="mppw-checkbox"></span>${ i18n.thursdayLabel }</label> <label><input name="meetingDays" value="6" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="32" data-filterdayname="fri"/> <span class="mppw-checkbox"></span>${ i18n.fridayLabel }</label> <label><input name="meetingDays" value="7" type="checkbox" class="meetingDays search-option advanced-option" data-checkboxvalue="64" data-filterdayname="sat"/> <span class="mppw-checkbox"></span>${ i18n.saturdayLabel }</label></div><label class="mppw-form-field__label">${ i18n.meetingDaysLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><div class="mppw-form-field__control meeting-times" value=""><label><input name="meetingTimes" value="morning" type="checkbox" class="meetingTimes search-option advanced-option" data-checkboxvalue="1" data-filtertimename="morning"/> <span class="mppw-checkbox"></span>${ i18n.morningLabel }</label> <label><input name="meetingTimes" value="lunchtime" type="checkbox" class="meetingTimes search-option advanced-option" data-checkboxvalue="2" data-filtertimename="lunchtime"/> <span class="mppw-checkbox"></span>${ i18n.lunchLabel }</label> <label><input name="meetingTimes" value="afternoon" type="checkbox" class="meetingTimes search-option advanced-option" data-checkboxvalue="4" data-filtertimename="afternoon"/> <span class="mppw-checkbox"></span>${ i18n.afternoonLabel }</label> <label><input name="meetingTimes" value="evening" type="checkbox" class="meetingTimes search-option advanced-option" data-checkboxvalue="8" data-filtertimename="evening"/> <span class="mppw-checkbox"></span>${ i18n.eveningLabel }</label></div><label class="mppw-form-field__label">${ i18n.meetingTimesLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><div class="mppw-form-field__control meets-online" value=""><label><input name="meetsOnline" id="meetsOnline" value="true" type="checkbox" class="meetsOnline search-option advanced-option"/> <span class="mppw-checkbox"></span>${ i18n.meetsOnline }</label></div><label class="mppw-form-field__label">${ i18n.meetsOnline }</label></div></div><div class="mppw-centered"><div class="mppw-btn primary" id="searchButton">${ i18n.searchButtonText }</div></div></form></div><div id="emptyContainer"><i class="mppw-spinner"></i></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div><div id="viewMoreContainer"></div><div id="suggestGroupButtonContainer" class="mt-15"><div class="mppw-centered"><input type="submit" class="mppw-btn primary" id="suggestAGroupButton" value="${ i18n.suggestGroupButton }"/></div></div></div><div id="suggest-a-group-container" style="display: none"><div id="goBackButton" class="mppw-btn secondary">${ i18n.goBackButton }</div><div id="loadingContainer"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none"></div><div id="suggestGroupDetailsContainer" style="display: none"><div class="mppw-form-wrapper"><h1>${ i18n.suggestGroupTitle }</h1><div><form class="mppw-form mppw-form-validate" id="suggestAGroupForm"><div class="mppw-form-field mppw-form-field__static-container"><input name="groupName" class="mppw-form-field__control" type="text" id="groupName" required/> <label class="mppw-form-field__label" for="groupName">${ i18n.groupName } *</label></div><div class="mppw-form-field mppw-form-field__static-container"><textarea name="description" class="mppw-form-field__control" type="text" id="description" required value=""></textarea> <label class="mppw-form-field__label" for="description">${ i18n.groupDescription } *</label></div><div class="suggest-group-row"><div class="full-width"><div class="mppw-form-field mppw-form-field__static-container"><select name="newGroupCongregationId" class="mppw-form-field__control search-option" id="newGroupCongregationId" required value=""></select> <label class="mppw-form-field__label" for="newGroupCongregationId">${ i18n.congregationLabel } *</label></div></div><div class="full-width"><div class="mppw-form-field mppw-form-field__static-container"><select name="newGroupGroupFocusId" class="mppw-form-field__control search-option advanced-option" id="newGroupGroupFocusId" value=""></select> <label class="mppw-form-field__label" for="newGroupGroupFocusId">${ i18n.groupFocusLabel }</label></div></div></div><div class="suggest-group-row"><div class="full-width"><div class="mppw-form-field mppw-form-field__static-container"><select name="newGroupLifeStageId" class="mppw-form-field__control search-option advanced-option" id="newGroupLifeStageId" value=""></select> <label class="mppw-form-field__label" for="newGroupLifeStageId">${ i18n.lifeStageLabel }</label></div></div><div class="full-width"><div class="mppw-form-field mppw-form-field__static-container"><select name="newGroupMeetingDayId" class="mppw-form-field__control search-option advanced-option" id="newGroupMeetingDayId" value=""><option value="">${ i18n.anyDayOptionLabel }</option><option value="1">${ i18n.sundayOptionLabel }</option><option value="2">${ i18n.mondayOptionLabel }</option><option value="3">${ i18n.tuesdayOptionLabel }</option><option value="4">${ i18n.wednesdayOptionLabel }</option><option value="5">${ i18n.thursdayOptionLabel }</option><option value="6">${ i18n.fridayOptionLabel }</option><option value="7">${ i18n.saturdayOptionLabel }</option></select> <label for="newGroupMeetingDayId" class="mppw-form-field__label">${ i18n.meetingDayLabel }</label></div></div></div><div class="mppw-form-field mppw-form-field__static-container"><input name="newGroupMeetingTime" class="mppw-form-field__control" type="time" id="newGroupMeetingTime"/> <label for="newGroupMeetingTime" class="mppw-form-field__label">${ i18n.meetingTimeLabel }</label></div><div id="suggestGroupSubmitButton" class="mppw-btn primary">${ i18n.requestGroupButton }</div></form><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div></div></div></div></div>` ; //Form:

                this._$searchForm = this._root.querySelector("#searchForm");
                this._$suggestAGroupForm = this._root.querySelector("#suggestAGroupForm"); //Drop-downs:

                this._$congregationId = this._root.querySelector("#congregationId");
                this._$parentGroupId = this._root.querySelector("#parentGroupId");
                this._$groupFocusId = this._root.querySelector("#groupFocusId");
                this._$lifeStageId = this._root.querySelector("#lifeStageId");
                this._$newGroupCongregationId = this._root.querySelector("#newGroupCongregationId");
                this._$newGroupGroupFocusId = this._root.querySelector("#newGroupGroupFocusId");
                this._$newGroupLifeStageId = this._root.querySelector("#newGroupLifeStageId");
                this._$newGroupMeetingDayId = this._root.querySelector("#newGroupMeetingDayId");
                this._$searchButton = this._root.querySelector("#searchButton");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$advancedSearchLink = this._root.querySelector("#advancedSearchLink");
                this._$advancedSearchSection = this._root.querySelector("#advancedSearchSection");
                this._$viewMoreContainer = this._root.querySelector("#viewMoreContainer");
                this._$suggestAGroupButtonButton = this._root.querySelector("#suggestAGroupButton");
                this._$groupFinderContainer = this._root.querySelector("#group-finder-container");
                this._$suggestAGroupContainer = this._root.querySelector("#suggest-a-group-container");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$loginButtonContainer.innerHTML +=  `<div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${i18n.loginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="${i18n.loginButton}"/>` ;
                this._$loadingContainer.innerHTML +=  `<i class="mppw-spinner"></i>` ;
                this._$loginButton = this._root.querySelector("#loginButton");
                this._$goBackButton = this._root.querySelector("#goBackButton");
                this._$requestGroupButton = this._root.querySelector("#suggestGroupSubmitButton");
                this._$suggestAGroupButtonContainer = this._root.querySelector("#suggestGroupButtonContainer");
                this._$suggestGroupDetailsContainer = this._root.querySelector("#suggestGroupDetailsContainer");
                this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
                this._$resultMessageText = this._root.querySelector("#resultMessageText");
                this.ShowHideSuggestGroupButton();
                this._suggestGroupForm = new FormManager(this._$suggestAGroupForm);
                groupsService = new GroupsApiService();
                this._groupsService = groupsService;
                groupsService.GetConfigurations().then(function (data) {
                  DropdownBuilder.LoadDropdown(_this._$congregationId, data.congregations, i18n.congregationPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$groupFocusId, data.groupFocuses, i18n.groupFocusPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$lifeStageId, data.lifeStages, i18n.lifeStagePlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$parentGroupId, data.parentGroups, i18n.parentGroupPlaceHolderText); //suggest a group

                  DropdownBuilder.LoadDropdown(_this._$newGroupCongregationId, data.congregations, i18n.congregationPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$newGroupGroupFocusId, data.groupFocuses, i18n.groupFocusPlaceHolderText);
                  DropdownBuilder.LoadDropdown(_this._$newGroupLifeStageId, data.lifeStages, i18n.lifeStagePlaceHolderText);
                  var advancedSearchOpened = false;
                  var returnContext = ReturnContext.Get(ReturnContext.Categories.Groups);

                  if (!!returnContext && returnContext.Url == window.location.href) {
                    advancedSearchOpened = ReturnContext.ApplyFilter(returnContext.FormData, _this._$searchForm, _this._$advancedSearchSection);
                  } else {
                    advancedSearchOpened = QueryStringFilter.ApplyFilter(_this._$searchForm, _this._$advancedSearchSection);
                  }

                  AttributeFilter.ApplyFilter(_this, _this._$searchForm, true);
                  var isSuggestAGroupMode = LocalStorageManager.getItem(_isSuggestGroupModeKeyName) == "true";

                  if (isSuggestAGroupMode) {
                    _this.ShowSuggestAGroupForm();
                  } else {
                    //This could be improved since it duplicates code from below:
                    if (!!advancedSearchOpened) {
                      _this._$advancedSearchLink.innerHTML = i18n.hideAdvancedSearchLabel;
                      _this._$advancedSearchSection.style.display = "block";

                      _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                    }

                    _this._$searchButton.click();
                  }
                })["catch"](function (error) {
                  //TODO: Write this error into HTML:
                  console.error(error);
                });

                this._$requestGroupButton.addEventListener("click", function ($event) {
                  $event.preventDefault();

                  if (_this._suggestGroupForm.IsValid()) {
                    _this._$loadingContainer.style.display = "";
                    _this._$requestGroupButton.disabled = true;
                    var formData = new FormData(_this._$suggestAGroupForm);
                    groupsService.SuggestGroup(formData).then(function (val) {
                      _this._suggestGroupForm.Reset();

                      _this.SetMessage("success", _this._i18n.requestGroupSuccessMessage, true);

                      _this._$loadingContainer.style.display = "none";
                      _this._$requestGroupButton.disabled = false;
                    })["catch"](function (err) {
                      // How to present detailed error details?
                      // console.log(`Error details: `, err)
                      _this.SetMessage("danger", _this._i18n.requestGroupFailMessage, false);

                      _this._$loadingContainer.style.display = "none";
                      _this._$requestGroupButton.disabled = false;
                    });
                  }
                });

                this._$searchButton.addEventListener("click", function ($event) {
                  $event.preventDefault();

                  _this.RunGroupsSearch($event);
                });

                this._$advancedSearchLink.addEventListener("click", function (event) {
                  var searchMode = _this._$advancedSearchLink.getAttribute("data-searchmode");

                  if (searchMode === "0") {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.hideAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "block";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  } else {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.showAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "none";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "0");
                  }

                  _this._$parentGroupId.selectedIndex = "0";
                  _this._$groupFocusId.selectedIndex = _this.groupFocusId > 0 ? _this._$groupFocusId.selectedIndex : "0";
                  _this._$lifeStageId.selectedIndex = "0";
                  event.preventDefault();
                });

                this._$suggestAGroupButtonButton.addEventListener("click", /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            event.preventDefault();

                            _this.ShowSuggestAGroupForm();

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

                this._$goBackButton.addEventListener("click", function () {
                  _this._$groupFinderContainer.style.display = "";
                  _this._$suggestAGroupContainer.style.display = "none";

                  _this._suggestGroupForm.Reset();

                  _this._$searchButton.click();

                  LocalStorageManager.setItem(_isSuggestGroupModeKeyName, false);
                });

              case 52:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "ShowSuggestAGroupForm",
    value: function () {
      var _ShowSuggestAGroupForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._$groupFinderContainer.style.display = "none";
                this._$suggestAGroupContainer.style.display = "";
                LocalStorageManager.setItem(_isSuggestGroupModeKeyName, true);
                _context3.next = 5;
                return this.TryLoginUser();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ShowSuggestAGroupForm() {
        return _ShowSuggestAGroupForm.apply(this, arguments);
      }

      return ShowSuggestAGroupForm;
    }()
  }, {
    key: "ShowHideSuggestGroupButton",
    value: function ShowHideSuggestGroupButton() {
      if (this._$suggestAGroupButtonContainer) {
        this._$suggestAGroupButtonContainer.style.display = this.showSuggestAGroupButton === "true" ? "" : "none";
      }
    }
  }, {
    key: "RunGroupsSearch",
    value: function RunGroupsSearch(clickEvent) {
      var _this2 = this;

      var formData = new FormData(this._$searchForm);
      formData.append("ShowFullGroups", this.showFullGroups);
      formData.append("CountGroupInquiries", this.countGroupInquiries);
      formData.append("ShowFutureGroups", this.showFutureGroups);
      formData.append("MinistryId", this.ministryId);
      formData.append("GroupTypeId", this.groupTypeIdAttribute);
      formData["delete"]("meetsOnline");

      if (this._$searchForm.querySelector("#meetsOnline").checked) {
        formData.set("meetsOnline", true);
      }

      this._$emptyContainer.innerHTML = "<i class=\"mppw-spinner\"></i>";
      var resultsContainerHTML = "";
      this._$resultsContainer.innerHTML = resultsContainerHTML;
      ReturnContext.Set(ReturnContext.Categories.Groups, formData);

      this._groupsService.SearchGroups(formData).then(function (data) {
        _this2._$emptyContainer.innerHTML = "";
        _this2._$viewMoreContainer.innerHTML = ""; // Reset view more label

        if (data.length === 0) {
          _this2._$emptyContainer.innerHTML += "<div id=\"subscriptionsEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(_this2._i18n.noGroupsFoundMessage, "</span>\n\t\t\t\t\t\t</div>");
        } else {
          for (var i = 0; i < data.length; i++) {
            var _data$i = _objectSpread({}, data[i]),
                featured = _data$i.featured,
                isFull = _data$i.isFull,
                meetsOnline = _data$i.meetsOnline,
                imageUrl = _data$i.imageUrl,
                title = _data$i.title,
                description = _data$i.description,
                location = _data$i.location,
                id = _data$i.id,
                meetingDay = _data$i.meetingDay,
                meetingTime = _data$i.meetingTime,
                startDate = _data$i.startDate,
                totalParticipantsCount = _data$i.totalParticipantsCount,
                targetSize = _data$i.targetSize;

            if (isFull === false || _this2.showFullGroups !== null && _this2.showFullGroups === "true") {
              var capacityTitle = _this2._i18n.titleCapacityLabel,
                  capacityLabel = '';

              if (isFull || targetSize !== null && Number(totalParticipantsCount) === Number(targetSize)) {
                capacityLabel = _this2._i18n.fullCapacityLabel;
              } else if (targetSize !== null && Number(totalParticipantsCount) < Number(targetSize)) {
                capacityLabel = totalParticipantsCount + ' ' + _this2._i18n.ofCapacityLabel + ' ' + targetSize;
              }

              var meetingDayText = meetingDay === 'Ongoing' ? _this2._i18n.ongoingLabel : meetingDay;
              var subtitlesArr = CardBuilder.BuildGroupSubtitlesArr(location, meetingDayText, meetingTime, startDate, _this2._i18n.alreadyMeetingLabel, capacityTitle, capacityLabel);
              var targetUrl = CardBuilder.BuildUrl(_this2.targetUrl, id, _this2._groupDetailWidgetIdParameterName);
              resultsContainerHTML += CardBuilder.BuildCard((CardBuilder.BuildBadge(isFull, _this2._i18n.groupFullLabel) || CardBuilder.BuildBadge(featured, _this2._i18n.featuredGroupLabel)) + CardBuilder.BuildBadge(meetsOnline, _this2._i18n.meetsOnline) + CardBuilder.BuildImage(imageUrl, 'group'), CardBuilder.BuildText(title, subtitlesArr, description), CardBuilder.BuildDetailsButton(id, targetUrl, _this2._i18n.seeDetailsButtonText, _this2._groupDetailWidgetIdParameterName), targetUrl, !(imageUrl === null || imageUrl === undefined));
            }
          }

          _this2._$resultsContainer.innerHTML += resultsContainerHTML; // If more items are returned display viewMoreLabel, matches event finder logic

          if (data.length > 20) {
            _this2._$viewMoreContainer.innerHTML = ""; // Clear existing messages

            _this2._$viewMoreContainer.innerHTML += "<div class=\"mppw-alert mppw-alert__info\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(_this2._i18n.viewMoreLabel, "</span>\n\t\t\t\t\t\t\t</div>");
          }
        }
      })["catch"](ErrorBuilder.RenderHandler(this._$emptyContainer));
    }
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this3 = this;

      this._$loadingContainer.style.display = "";
      return new Promise(function (resolve, reject) {
        UserService.GetCurrentUser().then(function (userInfo) {
          if (!!userInfo) {
            _this3.userLoggedIn = true;
            _this3._$loginButtonContainer.style.display = "none";
            _this3._$suggestGroupDetailsContainer.style.display = "";
          } else {
            _this3._$loginButtonContainer.style.display = "";
            _this3._$suggestGroupDetailsContainer.style.display = "none";
          }

          _this3._$loadingContainer.style.display = "none";
          resolve();
        }, function () {
          _this3._$loadingContainer.style.display = "none";
          _this3._$suggestGroupDetailsContainer.style.display = "none";
          _this3._$loginButtonContainer.style.display = "";
          resolve();
        });
      });
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      var _this4 = this;

      var autoHideMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";

      if (autoHideMessage) {
        setTimeout(function () {
          _this4.HideMessage();
        }, 10000);
      }
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Group Finder",
        tag: "mpp-group-finder",
        configurationItems: [{
          name: "Target URL",
          attribute: "targeturl",
          description: "Defines the navigation path to Group Details. When a specific Group is chosen, the ID is appended to this route.",
          required: true,
          type: "url"
        }, {
          name: "Count Group Inquiries",
          attribute: "countgroupinquiries",
          description: "Allows Group Inquiries to be counted towards the Group's target size (Default: False).",
          required: false,
          type: "bool"
        }, {
          name: "Show Full Groups",
          attribute: "showfullgroups",
          description: "Allows Groups that are full to be displayed. A group is considered full when the Target Size is met or Group is Full is set to 'true.' When full Groups are displayed, they are marked with a badge (Default: False).",
          required: false,
          type: "bool"
        }, {
          name: "Show Future Groups",
          attribute: "showfuturegroups",
          description: "Allows Groups that haven't yet reached their start date to be displayed.",
          required: false,
          type: "bool"
        }, {
          name: "Congregation",
          attribute: "congregationid",
          description: "Filters the results by Congregation ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Congregations",
          fkFilter: "",
          fkSingleName: "Congregation"
        }, {
          name: "Key Word",
          attribute: "keyword",
          description: "Filters results using key words. A Key Word search looks for a match in the Group Name, Group Description, Program Name, and/or Ministry Name, so choose key word attributes strategically. Valid Values: All standard characters; spaces should be replaced with a plus (+) (Default: Empty or NULL).",
          required: false,
          type: "text"
        }, {
          name: "Ministry",
          attribute: "ministryid",
          description: "Filters by a Ministry ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Ministries",
          fkFilter: "",
          fkSingleName: "Ministry"
        }, {
          name: "Meets Online",
          attribute: "meetsonline",
          description: "Filters by Meets Online field.",
          required: false,
          type: "bool"
        }, {
          name: "Neighborhood (Parent Group)",
          attribute: "parentgroupid",
          description: "Filters by the Parent Group ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Groups",
          fkFilter: "",
          fkSingleName: "Parent Group"
        }, {
          name: "Group Focus",
          attribute: "groupfocusid",
          description: "Filters the results by Group Focus ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Group_Focuses",
          fkFilter: "",
          fkSingleName: "Group Focus"
        }, {
          name: "Group Type",
          attribute: "grouptypeid",
          description: "Filters by Group Type",
          required: false,
          type: "foreignkey",
          fkTable: "Group_Types",
          fkFilter: "",
          fkSingleName: "Group Type"
        }, {
          name: "Life Stage",
          attribute: "lifestageid",
          description: "Filters the results by Life Stage ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "Life_Stages",
          fkFilter: "",
          fkSingleName: "Life Stage"
        }, {
          name: "Meeting Days",
          attribute: "meetingdays",
          description: "Filters the results by one or more Meeting Days. (Default: Empty or NULL).",
          required: false,
          type: "multi-select",
          listValues: [{
            label: "All Days",
            value: ""
          }, {
            label: "Sunday",
            value: 1
          }, {
            label: "Monday",
            value: 2
          }, {
            label: "Tuesday",
            value: 3
          }, {
            label: "Wednesday",
            value: 4
          }, {
            label: "Thursday",
            value: 5
          }, {
            label: "Friday",
            value: 6
          }, {
            label: "Saturday",
            value: 7
          }]
        }, {
          name: "Meeting Time",
          attribute: "meetingtimes",
          description: "Filters the results by Meeting Time. (Default: Empty or NULL).",
          required: false,
          type: "multi-select",
          listValues: [{
            label: "Morning",
            value: "morning"
          }, {
            label: "Lunchtime",
            value: "lunchtime"
          }, {
            label: "Afternoon",
            value: "afternoon"
          }, {
            label: "Evening",
            value: "evening"
          }]
        }, {
          name: "Show Suggest a Group Button",
          attribute: "showsuggestagroupbutton",
          description: "If true, shows the \"Suggest a Group\" button",
          required: false,
          type: "bool"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["countgroupinquiries", "showfullgroups", "showfuturegroups", "targeturl", "target", "congregationid", "ministryid", "keyword", "parentgroupid", "citypostalcode", "groupfocusid", "lifestageid", "meetingdays", "showsuggestagroupbutton", "grouptypeid"];
    }
  }]);

  return MppGroupFinder;
}(ComponentBase);
MppGroupFinder.registerComponent(MppGroupFinder.WidgetDetails.tag, MppGroupFinder);